import { Trans, useTranslation } from '@pancakeswap/localization'
import { AutoColumn, LockIcon, Text } from '@pancakeswap/uikit'
import { DisableCard } from 'components/Card'

/**
 * A deposit box the position does not need. With `requiredSymbol` it names the token that is needed; with `atEdge` it says the
 * price sits exactly on a bound of the range (2026-10-02: a starting price one tick from the typed max locked BNB with the
 * generic "outside your range" text, which read as wrong).
 */
export default function LockedDeposit({
  children,
  locked,
  requiredSymbol,
  atEdge,
  ...rest
}: {
  children?: React.ReactNode
  locked: boolean
  requiredSymbol?: string
  atEdge?: boolean
  [key: string]: unknown
}) {
  const { t } = useTranslation()
  if (!locked) return <>{children}</>
  return (
    <DisableCard {...rest}>
      <AutoColumn justify="center" gap="8px">
        <LockIcon width="24px" height="24px" color="textDisabled" />
        <Text bold color="textDisabled" textAlign="center" data-testid="locked-deposit-note">
          {requiredSymbol ? (
            atEdge ? (
              t('The price sits on the edge of your range, so this position holds only %symbol%. Deposit %symbol% only.', { symbol: requiredSymbol })
            ) : (
              t('The price is outside your range, so this position holds only %symbol%. Deposit %symbol% only.', { symbol: requiredSymbol })
            )
          ) : (
            <Trans>The market price is outside your specified price range. Single-asset deposit only.</Trans>
          )}
        </Text>
      </AutoColumn>
    </DisableCard>
  )
}
